import type { AxiosResponse } from 'axios';
import { camelizeKey } from 'helpers';
import { camelizeKeys } from 'humps';

export const getResponseCallback =
  ({ camelize = true } = {}) =>
  (response: AxiosResponse) => {
    if (
      camelize &&
      response.data &&
      response.headers['content-type']?.includes('application/json')
    ) {
      response.data = camelizeKeys(response.data, (key, convert) =>
        camelizeKey(key, convert),
      );
    }

    return response;
  };
